module.exports = __webpack_public_path__ + "img/dashboard-admin.504341e8.svg";